export default __webpack_public_path__ + "static/media/padaria-600x600.1f4c1ff5.jpg";